/**
 * Get current time in milliseconds
 */
export function currentTimeMillis(): number {
  return Date.now();
}
